module.exports = __webpack_public_path__ + "media/assets/icons/notebook-d5322ff50ca1e066f7ef7671b2dcb76b.svg";